import { Formik } from "formik";
import AutocompleteV2 from "../component/AutocompleteObjectV2";
import CustomTabMenu from "../component/CustomTabMenu";
import { danhSachTabKhoBaoHiem } from "./Constant";
import { useContext, useEffect, useRef, useState } from "react";
import { AppContext } from "../appContext/AppContext";
import { searchList } from "./DanhMucServices";
import { TYPE_KHO } from "../utils/Constant";
import { searchListCN, searchListKho } from "../utils/ServicesUtils";

export const KhoBaoHiem: React.FC = () => {
  const { setIsLoading } = useContext(AppContext);
  const [listKho, setListKho] = useState<any>();
  const [typeKho, setTypeKho] = useState<any>();
  const [listCodeCN, setListCodeCN] = useState<any>([]); // list code chức năng
  const [columns, setColumns] = useState<any>([]);

  useEffect(() => {
    getListKho();
  }, [])

  useEffect(() => {
    const listTab: any = []
    if (!listCodeCN?.length) return setColumns(listTab);
    danhSachTabKhoBaoHiem(typeKho, listCodeCN).map((item) => {
      if (typeof item === "object") listTab.push(item)
    })
    setColumns(listTab)

  }, [listCodeCN])

  useEffect(() => {
    typeKho?.id && getListChucNang();
  }, [typeKho?.id])


  const getListKho = async () => {
    try {
      setIsLoading(true);
      let { data } = await searchListKho({
        "pageIndex": 1,
        "pageSize": 100,
        "warehouseType": TYPE_KHO.BAO_HIEM
      });
      setTypeKho(data?.data?.content[0])
      setListKho(data?.data?.content);

    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };


  const getListChucNang = async () => {
    try {
      setIsLoading(true);
      let { data } = await searchListCN({
        id: typeKho?.id
      });
      setListCodeCN(data?.data?.warehouseTermClassReqs)
    } catch (error) {
      console.error(error);
    } finally {
      setIsLoading(false);
    }
  };

  const handleChangeTypeNhapKho = (type?: any) => {
    setTypeKho(type)
  }

  return (
    <Formik<any> initialValues={{}} onSubmit={() => { }}>
      <>
        <div className="bg-white h-100">
          <div className="flex-1 flex flex-column">
            <div className="flex bg-white spaces width-20 mt-10 ml-10" >
              <AutocompleteV2
                options={listKho || []}
                name="name"
                className="autocomplete-custom-renderform  radius spaces h-29"
                onChange={(type: any) => handleChangeTypeNhapKho(type)}
                value={typeKho || {}}
                isClearable={false}
              />
            </div>

            <CustomTabMenu
              danhsachTabs={columns}
              className="spaces pl-0"
            />
          </div>
        </div>
      </>
    </Formik>
  );
};

export default KhoBaoHiem;
